import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAuthService } from '../ports/auth-service.registry';
import { useAuthStore } from '../stores/authStore';

export function useLogout(): {
  logout: (variables: void) => void;
  isLoading: boolean;
} {
  const logout = useAuthStore((state) => state.logout);
  const queryClient = useQueryClient();

  const mutation = useMutation<void, Error, void>({
    mutationFn: async () => {
      const authService = getAuthService();
      await authService.logout();
    },
    onSuccess: () => {
      logout();
      queryClient.clear();
    },
  });

  return {
    logout: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
